export default __webpack_public_path__ + "static/media/delivery-green.47428bf1.svg";